export default __webpack_public_path__ + "static/media/Betco-Button.e234f82f.png";